import { render, staticRenderFns } from "./NgDateText.vue?vue&type=template&id=55a83ac4"
import script from "./NgDateText.vue?vue&type=script&lang=js"
export * from "./NgDateText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports